import styled from 'styled-components'

const Section = styled.section`
  display: flex;
  flex-direction: column;
`

const TopWrapper = styled.div`
  display: flex;
  flex-direction: column;
  order: ${({ isTuMobileLayout }) => (isTuMobileLayout ? 2 : 1)};
  margin-top: ${props => props.theme.size.spacing.lg};
  @media (min-width: ${props => props.theme.size.breakpoint['min-width'].md}) {
    order: 1;
    margin-top: 0;
  }
`

// Section One & Two is for Argos and Habitat - Removed or made permanent depending on GM AB test results
const TopWrapperSectionOne = styled.div`
  order: 1;
`

const TopWrapperSectionTwo = styled.div`
  order: 2;
`

const BottomWrapper = styled.div`
  order: ${({ isTuMobileLayout }) => (isTuMobileLayout ? 1 : 2)};
  @media (min-width: ${props => props.theme.size.breakpoint['min-width'].md}) {
    order: 2;
  }
`

export { Section, TopWrapper, BottomWrapper, TopWrapperSectionOne, TopWrapperSectionTwo }
